<template>
    <vue-progress-bar></vue-progress-bar>
    <header class="header" v-if="!inModal">
        <div class="container menu-container">
            <div class="menu is-desktop is-mobile">
                <div class="is-hidden-desktop">
                    <div id="nav-icon" class="navbar-burger">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <nav class="header__user-actions is-hidden-desktop is-left">
                    <a class="header__user-action header__user-action--search">
                        <img src="data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2019.1.1,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3csvg%20version='1.1'%20id='Layer_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%2047.1%2048.9'%20style='enable-background:new%200%200%2047.1%2048.9;'%20xml:space='preserve'%3e%3cstyle%20type='text/css'%3e%20.st0{fill:%235D5D5D;}%20%3c/style%3e%3cpath%20class='st0'%20d='M46.8,47.3L33.1,33.1c3.5-3.5,5.7-8.3,5.7-13.7C38.8,8.7,30.1,0,19.4,0S0,8.7,0,19.4s8.7,19.4,19.4,19.4%20c4.7,0,9-1.7,12.4-4.5l13.8,14.3c0.2,0.2,0.4,0.3,0.7,0.3c0.2,0,0.5-0.1,0.6-0.3C47.2,48.3,47.2,47.7,46.8,47.3z%20M19.4,36.9%20c-9.7,0-17.5-7.9-17.5-17.5S9.7,1.8,19.4,1.8s17.5,7.9,17.5,17.5S29.1,36.9,19.4,36.9z'/%3e%3c/svg%3e" v-bind:alt="__('Search')">
                    </a>
                </nav>
                <div class="header__logo">
                    <router-link v-bind:to="{ name : 'home' }">
                        <img src="../assets/images/primary-logo.svg" alt="n-Joy" />
                    </router-link>
                </div>
                <div class="header__links__container">
                    <nav class="header__links is-flex is-hidden-touch" id="headerNav">
                        <div class="navbar-item has-dropdown"
                             v-on:mouseleave="hideNavbarProductsDropdown"
                             v-on:mouseover="setNavbarProductsDropdownVisibility"
                        >
                            <a class="navbar-link is-arrowless">
                                {{ __('Products') }}
                            </a>

                            <div class="navbar-dropdown is-active"
                                 v-bind:class="{'is-block': showNavbarProductsDropdown}"
                                 v-on:click="hideNavbarProductsDropdown"
                                 v-on:mouseleave="hideNavbarProductsDropdown"
                            >
                                <div class="columns">
                                    <div class="column"
                                         v-bind:class="{ 'has-border' : activeHeaderMenuItem !== null }"
                                         v-if="showNavbarProductsDropdown"
                                    >
                                        <div v-for="(itemLevel1, key1) in menuProductCategories">
                                            <router-link class="navbar-item navbar-item__first-level"
                                                         v-bind:class="{ 'is-active' : activeHeaderMenuItem == 'product_' + key1 }"
                                                         v-bind:key="key1"
                                                         v-bind:to="{ name : 'products.index', params : { category : itemLevel1.slug } }"
                                                         v-if="itemLevel1?.visible_on_menu === '1'"
                                                         v-on:mouseover.native="setActiveHeaderMenuItem('product_' + key1)"
                                            >
                                                {{ itemLevel1.name }}
                                            </router-link>
                                        </div>

                                    </div>
                                    <div class="column" v-if="activeHeaderMenuItem">
                                        <div v-for="(itemLevel1, key1) in menuProductCategories">
                                            <div
                                                v-if="activeHeaderMenuItem === 'product_' + key1"
                                            >
                                                <router-link class="navbar-item see-all"
                                                             v-bind:to="{ name : 'products.index', params : { category : itemLevel1.slug } }"
                                                >
                                                    {{ __('See all products') }}
                                                </router-link>
                                                <div v-for="itemLevel2 in itemLevel1.children">
                                                    <div class="group"
                                                         v-if="itemLevel1.children && itemLevel1.visible_on_menu === '1'"
                                                    >
                                                        <router-link class="group__title"
                                                                     v-bind:to="getCategoryRoute(itemLevel2)"
                                                                     v-if="itemLevel2.visible_on_menu === '1'"
                                                        >
                                                            {{ itemLevel2.name }}
                                                        </router-link>

                                                        <div v-for="(itemLevel3, key3) in itemLevel2.children">
                                                            <router-link class="navbar-item"
                                                                         v-bind:key="key3"
                                                                         v-bind:to="{ name : itemLevel3.disable_overview == 1 ? 'products.show' : 'products.series', params : itemLevel3.disable_overview == 1 ? { product : itemLevel3.products ? itemLevel3.products.slug : '', pn : itemLevel3.products ? itemLevel3.products.pn : '' } : { category : itemLevel3.slug } }"
                                                                         v-if="itemLevel2.children && itemLevel2.visible_on_menu === '1' && itemLevel3.visible_on_menu === '1'"
                                                            >
                                                                {{ itemLevel3.name }}
                                                            </router-link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="column" v-if="activeHeaderMenuItem">
                                        <template v-for="(itemLevel1, key1) in menuProductCategories">
                                            <div class="product-info"
                                                 v-if="activeHeaderMenuItem === 'product_' + key1"
                                            >
                                                <div class="product-info__image">
                                                    <img v-bind:alt="itemLevel1.name"
                                                         v-bind:src="filesBaseUrl + itemLevel1.promo_image"
                                                         v-if="itemLevel1.promo_image"
                                                    />
                                                </div>
                                                <div class="product-info__text" v-html="itemLevel1.promo_text"></div>
                                                <a class="product-info__link"
                                                   v-bind:href="itemLevel1.promo_url"
                                                >
                                                    {{ itemLevel1.promo_url_text }}
                                                </a>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="navbar-item"
                             v-bind:class="{ 'has-dropdown is-hoverable' : item.items }"
                             v-for="(item, itemKey) in menuHeader"
                             v-if="menuHeader.length > 0"
                             v-on:mouseover="setNavbarDropdownVisibility"
                        >
                            <a v-bind:href="item.url"
                               v-html="item.name.replace('|', '<br />')"
                               v-if="item.url && item.url.includes('http')"
                            >
                            </a>
                            <router-link
                                v-bind:to="(item.url.charAt(0) !== '/' ? '/' : '') + item.url"
                                v-html="item.name.replace('|', '<br />')"
                                v-if="item.url && !item.url.includes('http')"
                            >
                            </router-link>

                            <div class="navbar-dropdown"
                                 v-if="item.items && item.items.length"
                                 v-on:click="hideNavbarDropdown"
                            >
                                <template v-for="(subitem, subitemKey) in item.items"
                                          v-if="showNavbarDropdown"
                                >
                                    <a class="navbar-link is-arrowless"
                                       v-bind:href="subitem.url"
                                       v-html="subitem.name.replace('|', '<br />')"
                                       v-if="subitem.url &&  subitem.url.includes('http')"
                                    >
                                    </a>
                                    <router-link class="navbar-link is-arrowless"
                                                 v-bind:to="(subitem.url.charAt(0) !== '/' ? '/' : '') + subitem.url"
                                                 v-html="subitem.name.replace('|', '<br />')"
                                                 v-if="subitem.url && !subitem.url.includes('http')"
                                    >
                                    </router-link>
                                </template>
                            </div>
                        </div>
                    </nav>

                    <form class="search-bar is-hidden" method="get" v-bind:action="apiBaseUrl + 'search'" v-on:submit.prevent="search">
                        <div class="field is-active">
                            <div class="control has-icons-left">
                                <input class="input" name="term" type="text"
                                       v-bind:placeholder="__('Search Dariado')"
                                       v-model="searchTerm"
                                       v-on:blur="searchInputBlur"
                                       v-on:input="searchProducts"
                                       autocomplete="off"
                                />
                                <span class="icon is-left is-small is-hidden-touch">
                                    <img src="../assets/images/icon-search-blue.png" alt="" />
                                </span>
                            </div>
                            <a class="header__user-action--search icon is-right is-small is-hidden-desktop">
                                <img src="data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2019.1.1,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3csvg%20version='1.1'%20id='Flat'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='168%20-64%20152%20152'%20style='enable-background:new%20168%20-64%20152%20152;'%20xml:space='preserve'%3e%3cstyle%20type='text/css'%3e%20.st0{fill:%235D5D5D;}%20%3c/style%3e%3cpath%20class='st0'%20d='M318.8,81.2c1.6,1.6,1.6,4.1,0,5.7c-1.6,1.6-4.1,1.6-5.7,0l0,0L244,17.7l-69.2,69.2c-1.6,1.6-4.1,1.6-5.7,0%20c-1.6-1.6-1.6-4.1,0-5.7L238.3,12l-69.2-69.2c-1.6-1.6-1.6-4.1,0-5.7c1.6-1.6,4.1-1.6,5.7,0L244,6.3l69.2-69.2%20c1.6-1.6,4.1-1.6,5.7,0c1.6,1.6,1.6,4.1,0,5.7L249.7,12L318.8,81.2z'/%3e%3c/svg%3e" alt="" />
                            </a>
                        </div>
                        <div class="search-bar__results" v-show="showSearchResults">
                            <div class="search-bar__results__loader" v-if="searchLoader">
                                <svg xmlns="http://www.w3.org/2000/svg" height="5" viewBox="0 0 120 30" fill="#666"><circle cx="15" cy="15" r="15"><animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"/><animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"/></circle><circle cx="60" cy="15" r="9" fill-opacity="0.3"><animate attributeName="r" from="9" to="9" begin="0s" dur="0.8s" values="9;15;9" calcMode="linear" repeatCount="indefinite"/><animate attributeName="fill-opacity" from="0.5" to="0.5" begin="0s" dur="0.8s" values=".5;1;.5" calcMode="linear" repeatCount="indefinite"/></circle><circle cx="105" cy="15" r="15"><animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"/><animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"/></circle></svg>
                            </div>
                            <div v-if="!searchLoader">
                                <router-link class="search-bar__results__item"
                                             v-bind:key="index"
                                             v-bind:to="{ name : 'products.show', params : { product : product.slug, pn : product.pn }, query: getProductQueryParams(product) }"
                                             v-for="(product, index) in searchResults"
                                             v-on:click.native="vueRouterClickHandler('products.show', { product : product.slug, pn : product.pn }, getProductQueryParams(product))"
                                >
                                    <span class="search-bar__results__item__thumbnail"><img v-bind:alt="product.name" v-bind:src="filesBaseUrl + (product.files.Pictures[0] ? (product.files.Pictures[0].thumbnail_path != '' ? product.files.Pictures[0].thumbnail_path : product.files.Pictures[0].path) : '')" /></span>
                                    <span class="search-bar__results__item__name">
                                        <strong class="has-nowrap has-margin-right-15 is-inline-block">
                                            {{ product.name }}

                                            <template v-for="variant in product.variant_attributes" v-if="product.variant_attributes.length">
                                                <template v-if="variant.values.length > 1">
                                                    <template v-for="value in variant.values" v-if="variant.values.length > 0">
                                                        <template v-if="variant.value == value.id">
                                                            <span class="has-nowrap">
                                                                ({{ value.value }})
                                                            </span>
                                                        </template>
                                                    </template>
                                                </template>
                                            </template>
                                        </strong>
                                        <span class="tag is-light is-normal mr-1"
                                              v-if="product.wp_status === 'discontinued'"
                                        >
                                            {{ __('Discontinued')}}
                                        </span>
                                        <span class="is-inline-block">(<span class="has-nowrap">PN: {{ product.pn }} /</span> <span class="has-nowrap">EAN: {{ product.ean }}</span>)</span>
                                    </span>
                                </router-link>
                            </div>
                        </div>
                    </form>
                </div>

                <nav class="header__user-actions">
                    <a class="header__user-action header__user-action--search is-hidden-touch">
                        <img class="search-icon" src="data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2019.1.1,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3csvg%20version='1.1'%20id='Layer_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%2047.1%2048.9'%20style='enable-background:new%200%200%2047.1%2048.9;'%20xml:space='preserve'%3e%3cstyle%20type='text/css'%3e%20.st0{fill:%235D5D5D;}%20%3c/style%3e%3cpath%20class='st0'%20d='M46.8,47.3L33.1,33.1c3.5-3.5,5.7-8.3,5.7-13.7C38.8,8.7,30.1,0,19.4,0S0,8.7,0,19.4s8.7,19.4,19.4,19.4%20c4.7,0,9-1.7,12.4-4.5l13.8,14.3c0.2,0.2,0.4,0.3,0.7,0.3c0.2,0,0.5-0.1,0.6-0.3C47.2,48.3,47.2,47.7,46.8,47.3z%20M19.4,36.9%20c-9.7,0-17.5-7.9-17.5-17.5S9.7,1.8,19.4,1.8s17.5,7.9,17.5,17.5S29.1,36.9,19.4,36.9z'/%3e%3c/svg%3e" v-bind:alt="__('Search')">
                        <img class="close-icon" src="data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2019.1.1,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3csvg%20version='1.1'%20id='Flat'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='168%20-64%20152%20152'%20style='enable-background:new%20168%20-64%20152%20152;'%20xml:space='preserve'%3e%3cstyle%20type='text/css'%3e%20.st0{fill:%235D5D5D;}%20%3c/style%3e%3cpath%20class='st0'%20d='M318.8,81.2c1.6,1.6,1.6,4.1,0,5.7c-1.6,1.6-4.1,1.6-5.7,0l0,0L244,17.7l-69.2,69.2c-1.6,1.6-4.1,1.6-5.7,0%20c-1.6-1.6-1.6-4.1,0-5.7L238.3,12l-69.2-69.2c-1.6-1.6-1.6-4.1,0-5.7c1.6-1.6,4.1-1.6,5.7,0L244,6.3l69.2-69.2%20c1.6-1.6,4.1-1.6,5.7,0c1.6,1.6,1.6,4.1,0,5.7L249.7,12L318.8,81.2z'/%3e%3c/svg%3e" v-bind:alt="__('Search')">
                    </a>
                    <div class="navbar-item has-dropdown is-hoverable"
                         v-on:click="goToCheckoutPage"
                         v-on:mouseover="setNavbarDropdownVisibility"
                         v-show="shop"
                    >
                        <a class="navbar-link is-arrowless header__user-action header__user-action--cart ">
                            <img src="data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2019.1.1,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3csvg%20version='1.1'%20id='Layer_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%2048.9%2048.6'%20style='enable-background:new%200%200%2048.9%2048.6;'%20xml:space='preserve'%3e%3cstyle%20type='text/css'%3e%20.st0{fill:%235D5D5D;}%20%3c/style%3e%3cg%3e%3cpath%20class='st0'%20d='M23.9,43.7c0-2.7-2.1-4.9-4.7-4.9c-2.6,0-4.7,2.2-4.7,4.9c0,2.7,2.1,4.9,4.7,4.9%20C21.8,48.6,23.9,46.4,23.9,43.7z%20M16.3,43.7c0-1.8,1.3-3.2,3-3.2c1.7,0,3,1.4,3,3.2c0,1.8-1.3,3.2-3,3.2%20C17.6,46.9,16.3,45.5,16.3,43.7z'/%3e%3cpath%20class='st0'%20d='M36.5,48.6c2.6,0,4.7-2.2,4.7-4.9c0-2.7-2.1-4.9-4.7-4.9s-4.7,2.2-4.7,4.9C31.9,46.4,34,48.6,36.5,48.6z%20M36.5,40.5c1.7,0,3,1.4,3,3.2c0,1.7-1.3,3.2-3,3.2c-1.7,0-3-1.4-3-3.2C33.5,42,34.9,40.5,36.5,40.5z'/%3e%3cpath%20class='st0'%20d='M0.8,1.7h5c1.7,0,3.1,1.3,3.3,3l4,26.6c0.4,2.6,2.5,4.5,5,4.5h24.7c0.5,0,0.8-0.4,0.8-0.9%20c0-0.5-0.4-0.9-0.8-0.9H18.2c-1.7,0-3.1-1.3-3.3-3l-0.7-4.5h25.3c2.1,0,4-1.4,4.7-3.6l4.7-14.3c0.1-0.3,0-0.6-0.1-0.8%20c-0.2-0.2-0.4-0.4-0.7-0.4H11.3l-0.5-3.1C10.5,1.9,8.3,0,5.9,0h-5C0.4,0,0,0.4,0,0.9C0,1.4,0.4,1.7,0.8,1.7z%20M46.9,9.3l-4.3,13.1%20c-0.5,1.4-1.7,2.4-3.2,2.4H13.9L11.6,9.3L46.9,9.3z'/%3e%3c/g%3e%3c/svg%3e" v-bind:alt="__('Cart')">
                            <span class="badge" v-if="cartTotalPieces > 0">{{ cartTotalPieces }}</span>
                        </a>
                        <div class="navbar-dropdown is-hidden-touch is-right"
                             v-on:click="hideNavbarDropdown"
                        >
                            <div class="header__user-action--cart__dropdown"
                                 v-if="showNavbarDropdown"
                            >
                                <span v-if="!cart || cart.length == 0">{{ __('Your shopping cart is empty.') }}</span>
                                <img v-if="!cart || cart.length == 0" src="../assets/images/icon-cart-empty.png" alt="" />
                                <div class="cart" v-if="cart && cart.length > 0">
                                    <div class="cart__products__container">
                                        <div class="cart__products">
                                            <router-link class="cart__item"
                                                         v-bind:key="index"
                                                         v-bind:to="{ name : 'products.show', params : { product : product.slug, pn: product.pn } }"
                                                         v-for="(product, index) in cart"
                                            >
                                                <span class="cart__item__thumbnail"><img v-bind:alt="product.name" v-bind:src="filesBaseUrl + (product.files.Pictures[0] ? (product.files.Pictures[0].thumbnail_path != '' ? product.files.Pictures[0].thumbnail_path : product.files.Pictures[0].path) : '')" /></span>
                                                <span class="cart__item__name">{{ product.name }}</span>
                                                <span class="cart__item__quantity">x{{ product.quantity }}</span>
                                                <span class="cart__item__price">{{ currencyPosition == 'left' ? currencySign : ''}}{{ roundNumber(product.quantity * product.price.price, 2) }} {{ currencyPosition == 'right' ? currencySign : ''}}</span>
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="cart__total">
                                        <span>{{ __('Total') }}: {{ cartTotalPieces }} <span class="is-lowercase">{{ cartTotalPieces > 1 ? __('Products') : __('Product') }}</span></span>
                                        <span class="cart__total__price">{{ currencyPosition == 'left' ? currencySign : ''}}{{ cartTotalPrice }} {{ currencyPosition == 'right' ? currencySign : ''}}</span>
                                    </div>
                                    <div class="cart__button">
                                        <router-link class="btn is-secondary" v-bind:to="{ name : 'cart' }">
                                            {{ __('View cart') }}
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="navbar-item has-dropdown is-hoverable"
                         v-on:mouseover="setNavbarDropdownVisibility"
                    >
                        <a class="navbar-link is-arrowless header__user-action header__user-action--account"
                           v-bind:class="{'is-active': user}"
                           v-on:click="openMyAccountModal"
                        >
                            <img src="data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2019.1.1,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3csvg%20version='1.1'%20id='Layer_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%2048.9%2048.9'%20style='enable-background:new%200%200%2048.9%2048.9;'%20xml:space='preserve'%3e%3cstyle%20type='text/css'%3e%20.st0{fill:%235D5D5D;}%20.st1{fill:none;stroke:%235D5D5D;stroke-width:1.7311;stroke-miterlimit:10;}%20%3c/style%3e%3cg%3e%3cg%3e%3cpath%20class='st0'%20d='M24.5,1.7c12.5,0,22.7,10.2,22.7,22.7S37,47.2,24.5,47.2S1.7,37,1.7,24.5S11.9,1.7,24.5,1.7%20M24.5,0%20C11,0,0,11,0,24.5s11,24.5,24.5,24.5s24.5-11,24.5-24.5S38,0,24.5,0L24.5,0z'/%3e%3c/g%3e%3ccircle%20class='st1'%20cx='24.5'%20cy='19'%20r='7.9'/%3e%3cpath%20class='st1'%20d='M6.4,41c4.5-4.9,10.9-7.9,18-7.9c7.1,0,13.6,3.1,18,7.9'/%3e%3c/g%3e%3c/svg%3e" alt="" v-if="!user" />
                            {{ getUserInitials() }}
                        </a>
                        <div class="navbar-dropdown is-right is-hidden-touch"
                             v-if="user"
                             v-on:click="hideNavbarDropdown"
                        >
                            <router-link class="navbar-item"
                                         v-bind:to="{ name: 'my-account.my-orders' }"
                                         v-if="showNavbarDropdown"
                            >
                                {{ __('Your orders') }}
                            </router-link>
                            <router-link class="navbar-item"
                                         v-bind:to="{ name: 'my-account.my-products' }"
                                         v-if="showNavbarDropdown && false"
                                         v-on:click.native="showMyAccountModal = false"
                            >
                                {{ __('Your products') }}
                            </router-link>
                            <router-link class="navbar-item"
                                         v-bind:to="{ name: 'my-account.settings' }"
                                         v-if="showNavbarDropdown"
                            >
                                {{ __('Your account settings') }}
                            </router-link>
                            <a class="navbar-item"
                               v-if="showNavbarDropdown"
                               v-on:click="logoutUser"
                            >
                                {{ __('Sign out') }}
                            </a>
                            <hr class="dropdown-divider" v-if="Object.keys(languages).length > 1">
                            <div class="navbar-dropdown__languages" v-if="Object.keys(languages).length > 1">
                                <a class="navbar-item navbar-dropdown__login"
                                   v-if="showNavbarDropdown"
                                >
                                    <span class="header__user-action header__user-action--language has-margin-right-5">{{ language }}</span>
                                    {{ __('Change language') }}
                                </a>
                                <div class="dropdown-menu">
                                    <a class="navbar-item"
                                       v-for="(languageItem, languageKey) in languages"
                                       v-on:click="setLanguage(languageKey)"
                                    >
                                        {{ languageItem.name }}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="navbar-dropdown has-negative-right-position is-right is-hidden-touch"
                             v-if="!user"
                             v-on:click="hideNavbarDropdown"
                        >
                            <div class="navbar-dropdown__login has-text-centered"
                                 v-if="showNavbarDropdown"
                            >
                                <router-link class="btn is-secondary has-margin-bottom-5 has-nowrap is-fullwidth"
                                             v-bind:to="{ name: 'login' }"
                                >
                                    {{ __('Sign in') }}
                                </router-link>

                                <router-link class="has-nowrap"
                                             v-bind:to="{ name: 'register' }"

                                >
                                    {{ __('Create account') }}
                                </router-link>
                            </div>
                            <hr class="dropdown-divider" v-if="Object.keys(languages).length > 1">
                            <div class="navbar-dropdown__languages" v-if="Object.keys(languages).length > 1">
                                <a class="navbar-item navbar-dropdown__login"
                                   v-if="showNavbarDropdown"
                                >
                                    <span class="header__user-action header__user-action--language has-margin-right-5">{{ language }}</span>
                                    {{ __('Change language') }}
                                </a>
                                <div class="dropdown-menu">
                                    <a class="navbar-item"
                                       v-for="(languageItem, languageKey) in languages"
                                       v-on:click="setLanguage(languageKey)"
                                    >
                                        {{ languageItem.name }}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="modal is-active" v-if="showMyAccountModal">
                            <div class="modal-content is-small">
                                <div class="modal-content__title"><strong>{{ __('Your account') }}</strong></div>
                                <div class="has-margin-bottom-15 has-margin-left-30 has-margin-right-30 has-margin-top-15">
                                    <router-link class="is-block"
                                                 v-bind:to="{ name: 'my-account.my-orders' }"
                                                 v-if="showNavbarDropdown"
                                                 v-on:click.native="showMyAccountModal = false"
                                    >
                                        {{ __('Your orders') }}
                                    </router-link>
                                    <router-link class="is-block"
                                                 v-bind:to="{ name: 'my-account.my-products' }"
                                                 v-if="showNavbarDropdown"
                                                 v-on:click.native="showMyAccountModal = false"
                                    >
                                        {{ __('Your products') }}
                                    </router-link>
                                    <router-link class="is-block"
                                                 v-bind:to="{ name: 'my-account.settings' }"
                                                 v-if="showNavbarDropdown"
                                                 v-on:click.native="showMyAccountModal = false"
                                    >
                                        {{ __('Your account settings') }}
                                    </router-link>
                                    <a class="is-block"
                                       v-if="showNavbarDropdown"
                                       v-on:click="logoutUser"
                                    >
                                        {{ __('Sign out') }}
                                    </a>
                                </div>
                                <div class="modal-content__title" v-if="Object.keys(languages).length > 1">
                                    <strong>{{ __('Language Settings') }}</strong>
                                </div>
                                <div class="has-margin-bottom-15 has-margin-left-30 has-margin-right-30 has-margin-top-15"
                                     v-if="Object.keys(languages).length > 1"
                                >
                                    <a class="is-block"
                                       v-for="(languageItem, languageKey) in languages"
                                       v-on:click="setLanguage(languageKey)"
                                    >
                                        {{ languageItem.name }}
                                    </a>
                                </div>
                                <div class="modal-content__actions">
                                    <a class="btn is-secondary" v-on:click="closeMyAccountModal">{{ __('Close') }}</a>
                                </div>
                            </div>
                            <div class="modal-background"></div>
                        </div>
                    </div>
                </nav>

            </div>

            <div class="mobile-menu is-hidden-desktop">
                <ul class="mobile-menu__links__mobile">
                    <li v-if="activeHeaderMenuItem !== 'products'">
                        <router-link v-bind:to="{ name : 'home' }">
                            {{ __('Home') }}
                        </router-link>
                    </li>
                    <li class="has-sub-menu has-icon__arrow"
                        v-bind:class="{ 'is-open is-paddingless is-borderless' : activeHeaderMenuItem === 'products' }"
                    >
                        <a v-if="!activeProductMenuItem"
                           v-on:click="toggleActiveHeaderMenuItem('products')"
                        >
                            {{ __('Products') }}
                        </a>
                        <div class="sub-menu is-marginless is-paddingless"
                             v-bind:class="{ 'is-open' : activeHeaderMenuItem === 'products' }"
                        >
                            <template v-for="(itemLevel1, key1) in menuProductCategories">
                            <div class="sub-menu__item has-sub-menu has-icon__arrow"
                                 v-bind:class="{ 'is-open' : activeProductMenuItem === itemLevel1.id }"
                                 v-if="!activeProductMenuItem || activeProductMenuItem === itemLevel1.id"
                            >
                                <a v-bind:key="key1"
                                   v-on:click="toggleActiveProductMenuItem(itemLevel1.id)"
                                   v-if="itemLevel1.visible_on_menu === '1'"
                                >
                                    {{ itemLevel1.name }}
                                </a>

                                <div class="sub-menu__level-2"
                                     v-if="itemLevel1.visible_on_menu === '1' && activeProductMenuItem === itemLevel1.id"
                                >
                                    <div class="sub-menu__level-2__item">
                                        <router-link class="see-all"
                                                     v-bind:to="{ name : 'products.index', params : { category : itemLevel1.slug } }"
                                        >
                                            {{ __('See all products') }}
                                        </router-link>
                                    </div>

                                    <div class="sub-menu__level-2__item"
                                         v-for="(itemLevel2, key2) in itemLevel1.children"
                                    >
                                        <router-link
                                            class="sub-menu__level-2__link"
                                            v-bind:to="getCategoryRoute(itemLevel2)"
                                            v-if="itemLevel2.visible_on_menu === '1'"
                                        >
                                            {{ itemLevel2.name }}
                                        </router-link>

                                        <template v-for="(itemLevel3, key3) in itemLevel2.children">
                                        <router-link
                                            v-bind:key="key2 + '-' + key3"
                                            v-bind:to="{ name : itemLevel3.disable_overview == 1 ? 'products.show' : 'products.series', params : itemLevel3.disable_overview == 1 ? { product : itemLevel3.products ? itemLevel3.products.slug : '', pn : itemLevel3.products ? itemLevel3.products.pn : '' } : { category : itemLevel3.slug } }"
                                            v-if="itemLevel3.visible_on_menu === '1'"
                                        >
                                            {{ itemLevel3.name }}
                                        </router-link>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            </template>
                        </div>
                    </li>
                    <li v-bind:class="{ 'has-sub-menu' : item.items.length > 0, 'is-open' : activeHeaderMenuItem == item.id }"
                        v-for="(item, itemKey) in menuHeader"
                        v-if="menuHeader.length > 0 && activeHeaderMenuItem !== 'products'"
                    >
                        <router-link
                            v-bind:key="itemKey"
                            v-bind:to="(item.url.charAt(0) !== '/'  ? '/' : '') + item.url"
                            v-if="item.items.length === 0"
                        >
                            {{ item.name }}
                        </router-link>

                        <a v-if="item.items.length > 0"
                           v-on:click="toggleActiveHeaderMenuItem(item.id)"
                        >
                            {{ item.name }}
                        </a>
                        <div class="sub-menu"
                             v-bind:class="{ 'is-open' : activeHeaderMenuItem == item.id }"
                             v-if="item.items.length > 0"
                        >
                            <template v-for="(subitem, subitemKey) in item.items">
                                <a class="has-margin-bottom-15"
                                   v-bind:href="subitem.url"
                                   v-html="subitem.name.replace('|', '<br />')"
                                   v-if="subitem.url && subitem.url.includes('http')"
                                >
                                </a>
                                <router-link class="has-margin-bottom-15"
                                             v-bind:to="(subitem.url.charAt(0) !== '/' ? '/' : '') + subitem.url"
                                             v-html="subitem.name.replace('|', '<br />')"
                                             v-if="subitem.url && !subitem.url.includes('http')"
                                >
                                </router-link>
                            </template>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </header>

    <div class="nav-links is-hidden-touch">
        <span class="scroll-icon"></span>
    </div>

    <div class="view__container"
         v-bind:class="{ 'view__modal': inModal }"
    >
        <router-view v-if="ready === 0"></router-view>
    </div>

    <footer class="footer" v-if="isRouteLoaded && !inModal">
        <div class="footer__nav">
            <div class="container">
                <router-link v-bind:to="{ name : 'home' }" class="footer__logo has-margin-top-30">
                    <img src="../assets/images/secondary-logo.svg" alt="n-Joy" />
                </router-link>
            </div>
        </div>
        <div class="footer__newsletter">
            <div class="container">
                <div class="columns">
                    <div class="column is-10-tablet is-9-desktop">
                        <form-object v-bind:form-object="newsletterObject"
                                     v-if="newsletterObject"
                        ></form-object>
                    </div>
                    <div class="column social-column">
                        <div class="footer__social" v-if="setting('social_media')">
                            <a class="footer__social__icon"
                               target="_blank"
                               v-bind:href="social_media_item.url"
                               v-for="social_media_item in setting('social_media')"
                            >
                                <img alt="" v-bind:src="filesBaseUrl + social_media_item.icon" />
                                <img class="is-hover" alt="" v-bind:src="filesBaseUrl + social_media_item.icon_hover"  />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer__legal container">
            <div class="columns is-multiline">
                <div class="column is-12 is-6-desktop" v-if="menuFooterLegal.length > 0">
                    <template v-for="item in menuFooterLegal">
                        <a v-bind:href="item.url"
                           v-html="item.name.replace('|', '<br />')"
                           v-if="item.url && item.url.includes('http')"
                        ></a>
                        <router-link v-bind:to="(item.url.charAt(0) !== '/' ? '/' : '') + item.url"
                                     v-html="item.name.replace('|', '<br />')"
                                     v-if="item.url && !item.url.includes('http')"
                        ></router-link>
                    </template>
                </div>
                <div class="column is-12 is-6-desktop">
                    <div class="footer__copyright" v-wow="{'animation-name': 'fadeIn', 'animation-duration': '2s'}">
                        <span class="footer__copyright__text">
                            <img src="../assets/images/netopia.svg" alt="NETOPIA Payments" class="footer__copyright__payment" />
                            <span>Copyright © {{ new Date().getFullYear() }} <span class="footer__copyright__text__bold">Dariado</span>. {{ __('All rights reserved') }}</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </footer>

    <cookie-law storage-name="cookies:accepted" v-if="!inModal">
        <template v-slot="props">
            <div class="container">
                <div v-html="__('This site uses cookies to offer you a better experience. Find out more about our {link}.', { 'link':  '<a class=\'has-dotted-underline\' href=\'/legal-links\' target=\'_blank\'>' + __('Cookies Policy') + '</a>'})">

                </div>
                <div class="buttons-container has-margin-left-auto">
                    <a v-bind:href="'/gdpr?redirect=' + $route.path" class="btn has-margin-right-15 is-secondary-outlined is-thin"
                       v-on:click="props.open"
                    >
                        <span>{{ __('Cookie settings') }}</span>
                    </a>
                    <button class="btn is-secondary"
                            v-on:click="cookiesAllowAll(); props.close()"
                    >
                        <span>{{ __('Accept cookies') }}</span>
                    </button>
                </div>
            </div>
        </template>
    </cookie-law>
</template>

<script>
import FormObject from "./components/FormObject.vue";
import Modal from "./components/Modal.vue";
import router from "./router.js";
import mixins from "./mixins.js";
import axios from "axios";
import store from "./store.js";
import CookieLaw from './components/CookieLaw.vue';
import imagesLoaded from "imagesloaded";
import {eventBus} from "./eventBus.js";
export default {
    components: {
        FormObject,
        Modal,
        CookieLaw,
    },
    mixins: [mixins],
    created: function () {
        // get settings
        this.getSiteSettings();

        // get ip
        this.getCurrentIpAddress();

        window.addEventListener("resize", this.resizeWindow);
        this.initRouterListeners();

        this.$nextTick(() => {
            this.setNewsletterSection();
        });

        router.afterEach(() => {
            this.isRouteLoaded = false;
        });

        window.vueApp = this;
    },
    data: () => ({
        activeHeaderMenuItem: null,
        activeProductMenuItem: null,
        defaultLanguage: 'en',
        inModal: false,
        isActiveShop: true,
        isRouteLoaded: false,
        languages: [],
        menuFooter: [],
        menuFooterLegal: [],
        menuHeader: [],
        menuProductCategories: [],
        newsletterObject: null,
        ready: 1,
        resizeWindowTimer: null,
        searchLoader: false,
        searchResults: [],
        searchTerm: '',
        searchInputTyping: false,
        searchTimer: null,
        showFooterNav: [],
        showMyAccountModal: false,
        showNavbarDropdown: false,
        showNavbarProductsDropdown: false,
        showSearchResults: false,
    }),
    head: {
        link: [
            { rel: 'canonical', href: 'http://example.com/#!/contact/', id: 'canonical' },
        ],
    },
    methods: {
        /*abortAllXhrRequests: function () {
            this.abortAllXhrRequests();
        },*/
        checkUserCountry: function () {
            if (this.user.country !== null && this.user.country !== '') {
                this.$http.get(this.apiBaseUrl + 'country_shop_status?country=' + this.user.country).then(function (response) {
                    this.isActiveShop = response.body.result;
                    this.setCountry(this.user.country.toLowerCase());
                    this.setShop(this.isActiveShop);
                }.bind(this));
            }
        },
        closeMyAccountModal: function () {
            this.showMyAccountModal = false;
        },
        hideNavbarDropdown: function () {
            this.unsetActiveHeaderMenuItem();
            this.unsetActiveProductMenuItem();
            this.showNavbarDropdown = false;
        },
        hideNavbarProductsDropdown: function () {
            this.unsetActiveHeaderMenuItem();
            this.unsetActiveProductMenuItem();
            this.showNavbarProductsDropdown = false;
        },
        getCategoryRoute(category) {
            if (Object.keys(category.children).length === 1
                && category.children[0].disable_overview === '1'
                && category.children[0].products
            ) {
                return {
                    name: 'products.show',
                    params: {
                        product: category.children[0].products.slug,
                        pn: category.children[0].products.pn,
                    }
                };
            }


            return {
                name : Object.keys(category.children).length > 0 ? 'products.index' : 'products.series',
                params : {
                    category : category.slug
                }
            };
        },
        getCart: function () {
            if (window.localStorage && localStorage.getItem('dariado-cart') != 'null') {
                this.updateCart(JSON.parse(localStorage.getItem('dariado-cart')), false);
            }
            if (window.localStorage && localStorage.getItem('dariado-cart-updated-at') != 'null') {                ;
                store.commit('setCartUpdatedAt', localStorage.getItem('dariado-cart-updated-at'));
            }

            if (!this.user) {
                return;
            }

            this.getSavedCart();
        },
        getCurrentIpAddress: function () {
            if (this.user && this.user.country !== null && this.user.country !== '') {
                this.checkUserCountry();
                return;
            }
            this.$http.get(this.ipApiUrl).then(function (response) {
                this.$http.get(this.apiBaseUrl + 'country_check?ip=' + response.body.ip).then(function (response) {
                    this.isActiveShop = response.body.status.result;
                    this.setCountry(response.body.countryCode.toLowerCase());
                    this.setShop(this.isActiveShop);

                    if (localStorage.getItem('language') === null &&
                        Object.keys(this.languages).length &&
                        Object.keys(this.languages).includes(response.body.default_language.toLowerCase()) &&
                        !this.$route.query.preview
                    ) {
                        this.setLanguage(response.body.default_language.toLowerCase());
                        return;
                    }

                    if (Object.keys(this.languages).length &&
                        !Object.keys(this.languages).includes(response.body.default_language.toLowerCase()) &&
                        !this.$route.query.preview
                    ) {
                        this.setLanguage(this.defaultLanguage);
                    }

                    }.bind(this));
            }.bind(this));
        },
        getProductQueryParams: function(product) {
            let query = null;

            if (product.variant_attributes.length && product.variant_attributes[0].values.length > 1) {
                query = {};
                query['variants[' + product.variant_attributes[0].id + ']'] = product.variant_attributes[0].value;
            }

            return query;
        },
        getSiteSettings: function () {
            const app = this;
            this.$http.get(this.apiBaseUrl + 'site_settings?lang=' + this.language + '&country=' + this.country).then(function (response) {
                this.languages = response.body.languages;
                store.commit('setLanguageStrings', response.body.strings);
                this.menuHeader = response.body.menu['Header'];
                this.menuFooter = response.body.menu['Footer'];
                store.commit('setSettings', response.body.settings);

                this.menuProductCategories = response.body.menu_product_categories;
                this.$nextTick(function () {
                    this.setHeaderNavigationFontSize();
                }.bind(this));

                if (Object.keys(this.languages).length &&
                    !Object.keys(this.languages).includes(this.language) &&
                    !this.$route.query.preview
                ) {
                    this.setLanguage(this.defaultLanguage);
                }

                this.ready--;
            }.bind(this)).catch(error => {
                console.log(error.response);
                console.log('There was an error fetching data from API. Error code ' + error.response.status)
            });
        },
        getUserInitials: function () {
            if (!this.user) {
                return '';
            }
            const name = this.user.name;

            if (typeof name === 'undefined') {
                return '';
            }

            const initials = name.match(/\b\w/g) || [];

            return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
        },
        goToCheckoutPage: function () {
            router.push({ name: 'cart' }).catch(err => {
                // Ignore the error regarding  navigating to the page they are already on.
                if (
                    err.name !== 'NavigationDuplicated' &&
                    !err.message.includes('Avoided redundant navigation to current location')
                ) {
                    console.error(err);
                }
            });
        },
        init: function () {
            if (router.currentRoute.value.query.modal) {
                this.inModal = true;
            }
            this.getCart();
        },
        openMyAccountModal: function () {
            if (!this.user) {
                router.push({ name: 'login' });
            } else {
                this.showMyAccountModal = true;
            }

        },
        setNewsletterSection: function() {
            this.$http.get(this.apiBaseUrl + 'page/newsletter-section-in-footer?lang=' + this.language + (router.currentRoute.value.query.preview ? '&preview=true' : '')).then(function (response) {
                let page = response.body;

                if (!page.objects) {
                    return;
                }

                if (!page.objects.length) {
                    return;
                }


                if (page.objects[0].type !== 'form') {
                    return;
                }

                if (page.objects[0].form_type !== 'newsletter') {
                    return;
                }

                this.newsletterObject = page.objects[0];
            }.bind(this));

        },
        resizeWindow: function (e) {
            clearTimeout(this.resizeWindowTimer);
            this.resizeWindowTimer = setTimeout(function(){
                this.setHeaderNavigationFontSize();
            }.bind(this), 500);

        },
        search: function (e) {
            const form = e.target;
            const formData = new FormData(e.target);

            router.push({ name: 'products.search', query: { term: formData.get('term') } }).catch(err => {
                // Ignore the error regarding  navigating to the page they are already on.
                if (
                    err.name !== 'NavigationDuplicated' &&
                    !err.message.includes('Avoided redundant navigation to current location')
                ) {
                    console.error(err);
                }
            });
        },
        searchInputBlur: function(e) {
            setTimeout(function(){
                this.showSearchResults = false;
            }.bind(this), 200);
        },
        searchProducts: function () {
            this.searchInputTyping = true;
            this.searchLoader = true;
            this.showSearchResults = true;

            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(function(){
                this.searchInputTyping = false;
                if (this.searchTerm.length < 2) {
                    this.searchResults = [];
                    this.searchLoader = false;
                    this.showSearchResults = false;
                } else {
                    this.searchResults = [];

                    // build filter URL params
                    let filterParams = 'country=' + this.country + '&lang=' + this.language + '&currency=' + this.currency + '&order=name|asc' + '&filter[search]=' + this.searchTerm + '&show_in_search=true';

                    this.$http.get(this.apiBaseUrl + 'products?' + filterParams).then(function (response) {
                        this.searchResults = response.body;
                        this.searchLoader = false;
                    }.bind(this))
                        .catch(e => {
                            console.log('There was an error fetching data from API. Error code ' + e.response.status);
                            this.searchLoader = false;
                        });
                }
            }.bind(this), 500);


        },
        setActiveHeaderMenuItem: function (key) {
            this.activeHeaderMenuItem = key;
        },
        setActiveProductMenuItem: function (key) {
            this.activeProductMenuItem = key;
        },
        setCountry: function (country) {
            store.commit('setCountry', country);
        },
        setLanguage: function (language) {
            language = language.toLowerCase();

            store.commit('setLanguage', language);
            localStorage.setItem('language', language);

            if (this.ready && this.ready > 0) {
                this.ready = this.ready + 1;
            }

            if (!this.ready) {
                this.ready = 1;
            }

            // get site settings
            this.getSiteSettings();

            this.showMyAccountModal = false;

            this.$nextTick(() => {
                this.setNewsletterSection();
            });
        },
        setHeaderNavigationFontSize: function () {
            clearTimeout(this.resizeWindowTimer);

            let spanElement = document.createElement("span");
            let contentText = 'Products';
            let fontSize = 18;
            for (let i = 0; i < this.menuHeader.length; i++) {
                contentText += this.menuHeader[i].name;
            }
            let content = document.createTextNode(contentText);
            spanElement.appendChild(content);
            spanElement.classList.add('is-uppercase');
            document.body.appendChild(spanElement);

            let marginRight = 40;
            let headerNav = document.getElementById('headerNav');
            let headerNavWidth = headerNav ? headerNav.offsetWidth : 0
            let navContainerLength = headerNavWidth - marginRight * this.menuHeader.length - 50;
            if (navContainerLength <= 0) {
                spanElement.remove();
                return;
            }

            while (spanElement.offsetWidth > navContainerLength) {
                if (marginRight > 20) {
                    marginRight = marginRight - 5;
                    navContainerLength = headerNavWidth - marginRight * this.menuHeader.length - 50;
                }  else {
                    fontSize = fontSize - 1;
                    spanElement.style.fontSize = fontSize + 'px';
                }
            }

            let navItems = document.getElementById('headerNav').children;
            for (let i = 0; i < navItems.length; i++) {
                if (i < navItems.length - 1) {
                    navItems[i].firstElementChild.style.marginRight = marginRight + 'px';
                }
                navItems[i].firstElementChild.style.fontSize = fontSize + 'px';
            }

            spanElement.remove();
        },
        setFooterNavVisibility: function (index) {
            let value = true;
            if (this.showFooterNav[index]) {
                value = !this.showFooterNav[index];
            }

            this.showFooterNav[index] = value;
        },
        setNavbarDropdownVisibility: function () {
            this.showNavbarDropdown = true;
        },
        setNavbarProductsDropdownVisibility: function () {
            this.showNavbarProductsDropdown = true;
        },
        setShop: function (shop) {
            store.commit('setShop', shop);
        },
        toggleActiveHeaderMenuItem: function (key) {
            if (this.activeHeaderMenuItem === key) {
                this.unsetActiveHeaderMenuItem(key);
            } else {
                this.setActiveHeaderMenuItem(key);
            }
        },
        toggleActiveProductMenuItem: function (key) {
            if (this.activeProductMenuItem === key) {
                this.unsetActiveProductMenuItem(key);
            } else {
                this.setActiveProductMenuItem(key);
            }
        },
        unsetActiveHeaderMenuItem: function () {
            this.activeHeaderMenuItem = null;
        },
        unsetActiveProductMenuItem: function () {
            this.activeProductMenuItem = null;
        },
        vueRouterClickHandler: function (name, params, query) {
            let route = router.resolve({
                name: name,
                params: params,
                query: query
            });

            //document.location = route.href;
        },
        initRouterListeners: function () {
            const app = this;
            router.beforeEach(function (to, from, next) {
                let query = {};

                if (to.query && to.query.preview) {
                    query = { preview: true };
                }

                if (to.name === 'login' && !to.query.redirect && !from.query.redirect) {
                    to.query.redirect = from.path;
                    query.redirect = from.path;

                    router.replace({ name: 'login', query: query }).catch(err => {
                        // Ignore the error regarding  navigating to the page they are already on.
                        if (
                            err.name !== 'NavigationDuplicated' &&
                            !err.message.includes('Avoided redundant navigation to current location')
                        ) {
                            console.error(err);
                        }
                    });
                    return;
                }



                if (to.name === 'login' && !to.query.redirect && from.query.redirect) {
                    to.query.redirect = from.query.redirect;
                    query.redirect = from.query.redirect;

                    router.replace({ name: 'login', query: query }).catch(err => {
                        // Ignore the error regarding  navigating to the page they are already on.
                        if (
                            err.name !== 'NavigationDuplicated' &&
                            !err.message.includes('Avoided redundant navigation to current location')
                        ) {
                            console.error(err);
                        }
                    });
                    return;
                }

                app.$nextTick(() => {
                    if (app.language && to.query.lang === app.language) {
                        return;
                    }

                    if (to.query.lang) {
                        app.setLanguage(to.query.lang);
                    }
                });

                if (app && typeof app.abortAllXhrRequests === 'function') {
                    app.abortAllXhrRequests();
                }

                next();
            });
            router.afterEach(function (to, from) {
                // reset meta tags for each page
                app.$nextTick(() => {
                    document.title = store.state.defaultMetaTitle;
                    document.querySelector('meta[name="description"]').setAttribute('content', store.state.defaultMetaDescription);
                });

                document.querySelector('.mobile-menu')?.classList.remove('is-open');
                document.querySelector('.navbar-burger')?.classList.remove('open');
                document.querySelector('header.header')?.classList.remove('open');
                app.$nextTick(() => {
                    app.unsetActiveHeaderMenuItem();
                    app.unsetActiveProductMenuItem();
                });

                const searchButtons = document.querySelectorAll('.header__user-action--search');
                const searchBar = document.querySelector('.search-bar');
                const headerLinks = document.querySelector('.header__links');
                if (searchButtons.length) {
                    searchButtons.forEach((searchButton) => {
                        searchButton.classList.remove('is-opened');
                    });
                    searchBar.classList.add('is-hidden');
                    headerLinks.classList.remove('is-hidden');
                }

                // get user info
                const user = store.state.user;
                if (user) {
                    axios.get(store.state.apiBaseUrlShop + 'get_logged_user', {
                        params: {
                            'email': user.email,
                            'token': user.token
                        }
                    }).then(function (response) {
                        store.commit('loginUser', response.data);
                        localStorage.setItem('user', JSON.stringify(response.data));
                    }).catch(function (e) {
                        store.commit('logoutUser');
                        localStorage.removeItem('user');
                    });
                }

                if (app) {
                    app.searchTerm = '';
                }

                if (!to.query.el) {
                    window.scrollTo(0, 0);
                }
            });
        },
    },
    mounted: function () {
        this.init();
    },
    router: router,
    watch: {
        '$route.query.modal': function (to) {
            if (to) {
                this.inModal = true;
                return;
            }

            this.inModal = false;

        }
    }
};
</script>
